import { useCallback } from 'react'
import Modal, { Styles } from 'react-modal'
import {
  selectModalLoading,
  selectModalProps,
  selectType,
  setType,
} from 'src/app/modal'
import { useAppDispatch, useAppSelector, useGetModalContent } from 'src/hooks'

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
// By default, the modal portal will be appended to the document's body.
Modal.setAppElement('#root')

const BaseModal = () => {
  const type = useAppSelector(selectType)
  const isModalLoading = useAppSelector(selectModalLoading)
  const dispatch = useAppDispatch()
  const onClose = useCallback(
    () => dispatch(setType({ type: null })),
    [dispatch]
  )
  const ModalContent = useGetModalContent(type)
  // forcing all props to be as existing here so we can more easily spread them onto an assortment of modals
  // each modal should handle whether the prop its expecting exists or not
  const props = useAppSelector(selectModalProps)!

  const customStyles: Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: '1px solid #DFE3E8',
      boxShadow:
        '0px 12px 24px rgba(19, 22, 25, 0.1), 0px 6px 12px rgba(19, 22, 25, 0.1)',
      borderRadius: '12px',
      padding: '16px',
      overflow: 'visible',
    },
    overlay: {
      display: isModalLoading ? 'none' : 'block',
      zIndex: 100,
    },
  }

  return (
    <>
      <Modal
        /* Object indicating styles to be used for the modal.
      It has two keys, `overlay` and `content`.
      See the `Styles` section for more details. */
        style={customStyles}
        /* Function that will be run when the modal is requested
      to be closed (either by clicking on overlay or pressing ESC).
      Note: It is not called if isOpen is changed by other means. */
        onRequestClose={onClose}
        isOpen={!!type}
      >
        <div className="w-60">
          {/* ignores unhelpful ts errors about props not aligning for different modals
// @ts-ignore*/}
          {ModalContent && <ModalContent {...props} />}
        </div>
      </Modal>
    </>
  )
}

export default BaseModal
